<template>
  <van-dialog v-model="show" @confirm="confirm">
    <div class="statement-warp">
      <div class="statement-con">
        <p class="tit">
          本政策概述：
        </p>
        <p class="item">
          我们即北京猿力教育科技有限公司及其关联公司（以下简称“本公司”），如何通过我们网页上的线上招聘系统及其他方式收集求职者的资料，以及我们如何处理（该词定义见下文）及可能会如何使用该等资料。
        </p>
        <p class="item">定义：</p>
        <p class="item">
          求职者：指任何透过该网页申请（直接或经一名代表间接）加入本公司的个人。
        </p>
        <p class="item">
          处理：包括收集、储存、检索、变更、披露或销毁个人资料。
        </p>
        <p class="item">
          个人资料：有关确认或识别个人的任何形式的信息，可能包括（但不限于）个人身份识别信息（如姓名、地址、照片、电子邮件地址、银行卡号、受聘详细资料、薪酬信息等）。
        </p>
        <p class="item">
          本政策载列了我们处理您向我们提供的任何个人资料（包括您通过我们的招聘网站（互联网址：[
          https://garden.yuanfudao.com/#/subsidy/collect
          ]（下文简称“招聘网站”）提供的信息））以及我们接收自您或第三方（如推荐人）的与您的工作申请有关的资料所遵照的依据。请仔细阅读以下内容，以了解我们有关您的资料的意见和惯例，以及我们将如何处理这些资料。您通过招聘网站或其他第三方途径向我们提供个人资料，即表示您承认及认可本政策。
        </p>
        <p class="item">
          本政策仅针对我们控制的个人资料：您可能会通过第三方提交您的信息，他们会根据自身的独立隐私政策处理您的个人资料。我们对该等第三方如何处理您的个人资料概不负责。
        </p>
        <p class="item">
          本政策可不时修订，而如果求职者获聘加入本公司，本政策不构成求职者的雇佣合约的一部分。
        </p>
        <p class="tit">1. 本公司处理个人资料的原因</p>
        <p class="item">
          本公司评核求职者的求职申请时，有必要处理求职者的个人资料，同时，处理及考虑求职者加入本公司的申请牵涉我们的合法业务权益，故处理求职者的个人资料是有需要的。
        </p>
        <p class="item">
          本公司亦会在以下情况处理个人资料（包括下文述及的特殊类别个人资料）：本公司为履行任何法例义务而有需要时；法律诉讼程序、执法行动或政府调查有所要求时；或与求职者的职务相关的情况下。
        </p>
        <p class="tit">2. 本公司收集的个人资料</p>
        <p class="item">
          本公司经由该网页及透过其他方式收集的个人资料包括但不限于以下类别：
          联系信息──（包括姓名、地址、邮箱、电话号码、微信）
          个人资料──（包括性别及出生日期、身份证号、婚姻状况）
          受雇及学历信息──（包括过往受雇纪录及曾担任的职位、资历、就读院校及曾获得的专业认证信息）。
        </p>
        <p class="item">
          本公司亦可能从求职者上载至该网页的任何求职信或工作样本中，收集其他类别个人资料。同时我们会就您的申请从第三方接收信息，如推荐人、招聘人员及提供背景检查的组织（在适用法律允许的情况下，这将/可能包括工作权利、犯罪记录背景调查、机动车记录背景调查及工作经验背景调查）。
        </p>
        <p class="item">
          我们收集的关于您对招聘网站使用的信息。当您使用我们的招聘网站时，我们会自动向您收集若干数据，包括IP地址或其他设备唯一标识符、cookie收集的有关您对门户网站使用的信息、移动运营商（若适用）、时区设置、操作系统及平台以及有关您对门户网站使用的信息（如完成职位申请的时间、页面浏览历史、申请记录等）（下文简称“使用信息”）。
        </p>
        <p class="tit">3.我们如何使用您的信息：</p>
        <p class="item">
          您理解并同意，您的信息将被本公司用于以下用途：识别及评估您是否适合相关职位；确保遵循我们的内部政策；确定及验证您的就业资格；开展背景调查（包括在适用法律允许的情况下，核实资料、资格及进行犯罪记录调查）；与您通信；
          管理、开发及改进门户网站；及向您发送与您的状况匹配的新职位通知。
        </p>
        <p class="tit">4. Cookie</p>
        <p class="item">
          我们采用cookie提升您在使用招聘网站时的体验。Cookie是安装在您设备上的一些小文件，我们可以通过其提供特定特性和功能。招聘网站会为内部流量监控、容量目的或招聘网站管理目的检测和使用您的IP地址或域名。
          我们仅使用绝对必需的cookie（即运营招聘网站必需的cookie），例如，包括使您能够登录招聘网站安全区域的cookie。
        </p>
        <p class="tit">5. 本公司如何保障个人资料</p>
        <p class="item">
          本公司将采取一切合理必要的步骤，确保实施恰当的保安措施，以保障个人资料。在厘定恰当的保安措施时，本公司会考虑科技发展情况，并且评估现有措施是否足以防范安全漏洞可能带来的损害风险。本公司已实施适当的保安措施，足以防范「处理」过程出现的风险，并且可预防任何人未经授权披露或非法披露资料，以及防止个人资料遭受意外损失、销毁或损毁。
        </p>
        <p class="item">
          您理解并同意，尽管本公司已采取了一系列适当安保措施，但是通过互联网传输信息并非绝对安全。虽然我们将竭尽所能保护您的个人资料，但我们无法保证通过招聘网站传输的您的信息的安全，任何该等传输应由您自担风险。当我们收到您的信息后，我们会采取适当的技术和组织措施保护您的个人资料免遭丢失、盗窃及未获授权的使用、访问或修改。
        </p>
        <p class="tit">6. 本公司与谁人共用个人资料</p>
        <p class="item">
          本公司可能会在有需要时，为招聘求职者一事涉及的合法业务目的，或为遵守适用法律规定，与本公司内部共用透过该网页及其他方式获取的个人资料。
        </p>
        <p class="item">
          本公司也可能向第三方披露个人资料，以便该等第三方代表本公司履行服务，或供法律／监管目的之用。在将个人资料披露予第三方时，本公司将实施合适保障措施以确保资料以合法方式处理并受到适当保护。（例如：为我们提供招聘支持的IT服务供应商；核实您作为申请一部分提供的信息的背景调查服务供应商；
          推荐人；及我们使用的人才招聘机构）
        </p>
        <p class="tit">7. 您的权利</p>
        <p class="item">
          如果您希望就经由招聘网站或其他方式所取得个人资料的处理，行使适用法律所赋予您的权利，您必须经书面作出要求，并向您当地的人力资源联络人提出有关要求。为确认您的身份及出于保安目的，本公司可向您索取额外资料，然后才会向您披露所需资料。
        </p>
        <p class="tit">8. 保留您的个人资料</p>
        <p class="item">
          我们会在求职者申请加入本公司的期间保留个人资料。如求职者没有加入本公司，我们会保留其个人资料，时间长短视乎本公司上述的合法业务权益需要而定，并且会依循适用法律及我们的保留政策及程序，在该期间过后，该等资料会被删除或设定为无法使用。
        </p>
        <p class="tit">9.其他</p>
        <p class="item">
          未来本政策若有任何变更，我们会在本网页发布。请经常进行核查，以查看本政策的任何更新或变动。
          欢迎提出有关本政策的问题、评论或要求，任何问题、评论或要求请发送至以下电子邮件地址：zhangjj@fenbi.com
          zhanghe02@fenbi.com
        </p>
        <p class="tit" style="text-align:center">
          北京猿力教育科技有限公司
        </p>
        <p class="tit" style="text-align:center">
          2020年7月3日
        </p>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import Vue from 'vue'
import { Dialog } from 'vant'
Vue.use(Dialog)
export default {
  name: 'g-statement',
  components: {},
  props: {
    value: Boolean,
  },
  data() {
    return {
      show: false,
    }
  },
  watch: {
    value(val) {
      this.show = val
    },
  },
  methods: {
    confirm() {
      this.$emit('input', false)
    },
  },
}
</script>
<style lang="less">
.offer-confirm {
  .van-dialog__content {
    height: 70vh;
  }
}
</style>
<style lang="less" scoped>
.statement-warp {
  height: 100%;
  padding: 0 0.2rem;
  margin: 0.1rem 0;
  overflow-x: hidden;
  overflow-y: scroll;
  .statement-con {
    background-color: #fff;
    .tit {
      padding: 0.16rem 0 0.12rem;
      font-size: 0.16rem;
      font-weight: 500;
      color: rgba(92, 92, 92, 1);
      line-height: 0.2rem;
      margin-bottom: 0;
    }
    .item {
      font-size: 0.14rem;
      line-height: 0.22rem;
      color: #666;
      margin: 0 0 0.16rem;
    }
  }
}
</style>
